import { Injectable } from '@angular/core';
import * as Keycloak from 'keycloak-js';
import { ConfigService } from './config.service';
import { Router } from '@angular/router';
import { Constants } from '../util/const/constants';

@Injectable({
  providedIn: 'root'
})
export class KeycloakService {
  private keycloakInstance: Keycloak.KeycloakInstance;
  private keycloakConfig:any

  private isMainTab: boolean = false;

  constructor(private configService:ConfigService, private router: Router) {
    console.log("[KeycloakService] :: Constructor");
    this.keycloakConfig = JSON.parse(localStorage.getItem('keycloak_config')) ;
    let authtype = localStorage.getItem('authType')
    console.log("[KeycloakService] :: Constructor authtype"+authtype);
    if (authtype == Constants.AUTH_TYPE.SSOUser){
      if (this.keycloakConfig == null) {
        this.configService.getConfigByName('keycloak_config', true);
      }
      if (!localStorage.getItem('main_tab_key')) {
        // This is the main tab
        let  keycloakInstance = this.configService.getKeycloakInstance();
        console.log("[KeycloakService] :: getKeycloakInstance "+JSON.stringify(keycloakInstance));
        if(keycloakInstance == null &&  (localStorage.getItem('keycloakAuthenticated') == "true" )) {
          console.log("[KeycloakService] :: keycloakInstance : null KEYCLOAK_AUTHENTICATED" + localStorage.getItem('keycloakAuthenticated'));
          this.handleKeycloakDuplicateTabs();
        } else{
          console.log("[KeycloakService] :: keycloakInstance not null : null KEYCLOAK_AUTHENTICATED" + localStorage.getItem('keycloakAuthenticated'));
    
          //this.router.navigateByUrl('login');
        }
        this.isMainTab = true;
        localStorage.setItem('main_tab_key', Date.now().toString());
        console.log("[KeycloakService] :: Constructor-Main Tab");
      } else {
        // Duplicate tab detected
        if (authtype == Constants.AUTH_TYPE.SSOUser){
          this.handleKeycloakDuplicateTabs();
        }
      }
      // Listen for tab closures
      window.addEventListener('storage', this.handleTabClosure.bind(this));

      // Remove the main tab key when the tab is closed
      window.addEventListener('beforeunload', () => {
        if (this.isMainTab) {
          localStorage.removeItem('main_tab_key');
        }
      });
    }
   }

  private handleKeycloakDuplicateTabs() {
    console.log("[KeycloakService] :: Constructor-Duplicated Tab");
    this.keycloakInstance = Keycloak({
      url: this.keycloakConfig.issuer,
      realm: this.keycloakConfig.realm,
      clientId: this.keycloakConfig.clientId,
    });
    let keyclaokData = JSON.parse(localStorage.getItem('keycloakInstance'));

    if (keyclaokData != null) {
      this.keycloakInstance.init({
        token: keyclaokData.token,
        idToken: keyclaokData.idToken,
        refreshToken: keyclaokData.refreshToken
      });

      this.keycloakInstance.tokenParsed = keyclaokData.tokenParsed;

      this.keycloakInstance
        .updateToken(5) // Ensure tokens are valid or refreshed
        .success(() => {
          console.log('Keycloak reinitialized from storage.');
          this.saveTokensToStorage(); // Save updated tokens
          return true;
        })
        .error((err) => {
          console.error('Token update failed:', JSON.stringify(err));
          return this.initFreshInstance();
        });

      this.configService.setKeycloakInstance(this.keycloakInstance);

    } else {
      this.router.navigateByUrl('login');
    }

    this.configService.setKeycloakInstance(this.keycloakInstance);
  }

  /**
   * Handle when the main tab is closed
   */
  private handleTabClosure(event: StorageEvent): void {
    if (event.key === 'main_tab_key' && !event.newValue) {
      console.log('Main tab closed. You can assign a new main tab.');
    }
  }

  

   // Initialize Keycloak: either fresh or from storage
  init() {
    console.log('[KeycloakService] :: init');
    /* const storedTokens = this.getTokensFromStorage();

    if (storedTokens.token && storedTokens.refreshToken) {
      // Reinitialize using stored tokens
      this.keycloakInstance.token = storedTokens.token;
      this.keycloakInstance.refreshToken = storedTokens.refreshToken;
      this.keycloakInstance.idToken = storedTokens.idToken;

      this.keycloakInstance
        .updateToken(5) // Ensure tokens are valid or refreshed
        .success(() => {
          console.log('Keycloak reinitialized from storage.');
          this.saveTokensToStorage(); // Save updated tokens
          return true;
        })
        .error((err) => {
          console.error('Token update failed:', err);
          return this.initFreshInstance();
        });

        this.configService.setKeycloakInstance(this.keycloakInstance);
    } else {
      // No tokens in storage, fresh initialization
      return this.initFreshInstance();
    } */
     
    return this.initFreshInstance();
  }

  // Fresh Keycloak initialization
  private initFreshInstance() {

    this.keycloakConfig = JSON.parse(localStorage.getItem('keycloak_config')) ;
    let initOptions = {
      url: this.keycloakConfig.issuer,
      realm: this.keycloakConfig.realm,
      clientId: this.keycloakConfig.clientId,
      checkLoginIframe: false,
      onLoad: 'check-sso', // 🔑 DO NOT auto-redirect to login
 			silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',				
      responseType: 'id_token token'
    };
    this.keycloakInstance = Keycloak(initOptions);
    return this.keycloakInstance;
    
  }

  

  // Save tokens to localStorage and notify other tabs
  private saveTokensToStorage(): void {
    localStorage.setItem('kc-token', this.keycloakInstance.token || '');
    localStorage.setItem('kc-refresh-token', this.keycloakInstance.refreshToken || '');
    localStorage.setItem('kc-id-token', this.keycloakInstance.idToken || '');
  }

  // Get tokens from localStorage
  private getTokensFromStorage(): { token: string | null; refreshToken: string | null; idToken: string | null } {
    return {
      token: localStorage.getItem('kc-token'),
      refreshToken: localStorage.getItem('kc-refresh-token'),
      idToken: localStorage.getItem('kc-id-token'),
    };
  }

 // Login Method
async login(user:string) {
    try {
      // Trigger login process
      await this.keycloakInstance.login({
        loginHint: user // optional, based on your logic
      });
  
      // At this point, the user is logged in and tokens are available
      console.log("User logged in successfully");
  
      // Store the relevant Keycloak state to localStorage
      this.storeKeycloakState();
  
      // Proceed with the next steps, if necessary
      this.router.navigateByUrl('/home');
    } catch (error) {
      console.error("Error during login:", error);
    }
  }
  
  // Store Keycloak state to localStorage
  private storeKeycloakState() {
    if (this.keycloakInstance.token) {
      localStorage.setItem('keycloak_token', this.keycloakInstance.token);
    }
    if (this.keycloakInstance.refreshToken) {
      localStorage.setItem('keycloak_refresh_token', this.keycloakInstance.refreshToken);
    }
    if (this.keycloakInstance.idToken) {
      localStorage.setItem('keycloak_id_token', this.keycloakInstance.idToken);
    }
    if (this.keycloakInstance.tokenParsed) {
      localStorage.setItem('keycloak_tokenParsed', JSON.stringify(this.keycloakInstance.tokenParsed));
    }
    if (this.keycloakInstance.realm) {
      localStorage.setItem('keycloak_realm', this.keycloakInstance.realm);
    }
  
    console.log("Stored Keycloak state in localStorage.");
  }
  

  ngOnDestroy(): void {
  
  }

}
